// FilterComponent.jsx
import React from 'react';
import '../../styles/FilterComponent.scss';

const FilterComponent = ({
  filterCategory,
  setFilterCategory,
  priceRange,
  setPriceRange,
  volumeRange,
  setVolumeRange,
  fragrance,
  setFragrance,
  availability,
  setAvailability,
  filterOptions,
  isMobileFilterOpen,
  onClose,
  onSearchClear,
  onClearAll
}) => {
  return (
    <>
      {isMobileFilterOpen && <div className="filter-overlay" onClick={onClose} />}
      <div className={`filter-wrapper ${isMobileFilterOpen ? 'mobile-open' : ''}`}>
        <div className="filter-component">
          <div className="filter-header">
            <h2 className="filter-title">
              <span className="filter-icon">🔍</span>
              Filters
            </h2>
            <div className="filter-actions">
              <button className="clear-all-btn" onClick={onClearAll} title="Clear all filters">
                Clear All
              </button>
              <button className="close-button" onClick={onClose} aria-label="Close filters">
                ✕
              </button>
            </div>
          </div>

          <div className="filter-content">
            {/* Category Filter */}
            <div className="filter-group">
              <label htmlFor="category" className="filter-label">
                <span className="label-icon">📦</span>
                Product Category
              </label>
              <select
                id="category"
                className="filter-select"
                value={filterCategory}
                onChange={(e) => setFilterCategory(e.target.value)}
              >
                {filterOptions?.categories?.map(category => (
                  <option key={category} value={category}>
                    {category}
                  </option>
                ))}
              </select>
            </div>

            {/* Volume Filter */}
            <div className="filter-group">
              <label htmlFor="volume" className="filter-label">
                <span className="label-icon">📏</span>
                Volume
              </label>
              <select
                id="volume"
                className="filter-select"
                value={volumeRange}
                onChange={(e) => setVolumeRange(e.target.value)}
              >
                {filterOptions?.volumes?.map(volume => (
                  <option key={volume} value={volume}>
                    {volume}
                  </option>
                ))}
              </select>
            </div>

            

            

            {/* Availability Filter */}
            <div className="filter-group">
              <label htmlFor="availability" className="filter-label">
                <span className="label-icon">✓</span>
                Availability
              </label>
              <select
                id="availability"
                className="filter-select"
                value={availability}
                onChange={(e) => setAvailability(e.target.value)}
              >
                <option value="All">All Products</option>
                <option value="In Stock">In Stock</option>
                <option value="Out of Stock">Out of Stock</option>
              </select>
            </div>
          </div>

          {/* Mobile Apply Button */}
          <div className="filter-footer">
            <button className="apply-filters-btn" onClick={onClose}>
              Apply Filters
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default FilterComponent;